import { useEffect, useState } from "react";
import Reveal from "@/components/Reveal";
import { ArrowUpRight } from "lucide-react";
import { useLang } from "@/i18n";
import { api, imgUrl } from "@/lib/api";

const PROJECTS = [
  {
    title: "Government Network Modernization",
    tag: "ICT Infrastructure",
    location: "Dili",
    img: "https://images.unsplash.com/photo-1558494949-ef010cbdcc31?auto=format&fit=crop&w=900&q=80",
  },
  {
    title: "NGO Cloud & Server Migration",
    tag: "Cloud & Hosting",
    location: "Baucau",
    img: "https://images.unsplash.com/photo-1551434678-e076c223a692?auto=format&fit=crop&w=900&q=80",
  },
  {
    title: "Campus Wi-Fi & Meraki Deployment",
    tag: "Networking",
    location: "Dili",
    img: "https://images.unsplash.com/photo-1510519138101-570d1dca3d66?auto=format&fit=crop&w=900&q=80",
  },
  {
    title: "Retail CCTV & Access Control Rollout",
    tag: "Security & CCTV",
    location: "Maliana",
    img: "https://images.pexels.com/photos/430208/pexels-photo-430208.jpeg?auto=compress&cs=tinysrgb&w=900",
  },
];

export default function Projects() {
  const { t } = useLang();
  const [projects, setProjects] = useState(PROJECTS);

  useEffect(() => {
    api
      .get("/projects")
      .then((r) => {
        if (Array.isArray(r.data) && r.data.length) {
          setProjects(r.data.map((p) => ({ title: p.title, tag: p.tag, location: p.location, img: p.image })));
        }
      })
      .catch(() => {});
  }, []);

  return (
    <section
      id="projects"
      data-testid="projects-section"
      className="bg-[#0F172A] px-6 md:px-12 lg:px-24 py-20 lg:py-32"
    >
      <Reveal>
        <p className="text-xs tracking-[0.25em] uppercase text-[#ED1C24] mb-4">
          {t("projects_label")}
        </p>
        <h2 className="font-display font-semibold text-white text-4xl sm:text-5xl tracking-tight mb-14">
          {t("projects_title1")}
          <br />
          {t("projects_title2").replace(".", "")}<span className="text-[#ED1C24]">.</span>
        </h2>
      </Reveal>

      <div className="grid sm:grid-cols-2 gap-5">
        {projects.map((p, i) => (
          <Reveal key={p.title} delay={(i % 2) * 0.1}>
            <div
              data-testid={`project-card-${i}`}
              className="group relative h-80 lg:h-96 overflow-hidden border border-white/10 cursor-pointer"
            >
              <img
                src={imgUrl(p.img)}
                alt={p.title}
                loading="lazy"
                className="w-full h-full object-cover grayscale group-hover:grayscale-0 group-hover:scale-105 transition-[filter,transform] duration-700"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-[#0B1120] via-[#0B1120]/30 to-transparent" />
              <div className="absolute bottom-0 left-0 right-0 p-6 flex items-end justify-between">
                <div>
                  <span className="inline-block text-[10px] tracking-[0.2em] uppercase bg-[#ED1C24] text-white px-3 py-1 mb-3">
                    {p.tag}
                  </span>
                  <h3 className="font-display font-semibold text-white text-xl lg:text-2xl leading-snug">
                    {p.title}
                  </h3>
                  <p className="text-xs text-slate-400 mt-1">{p.location}, Timor-Leste</p>
                </div>
                <span className="w-11 h-11 shrink-0 rounded-full border border-white/30 flex items-center justify-center text-white opacity-0 group-hover:opacity-100 group-hover:bg-[#ED1C24] group-hover:border-[#ED1C24] transition-all duration-500">
                  <ArrowUpRight size={18} />
                </span>
              </div>
            </div>
          </Reveal>
        ))}
      </div>
    </section>
  );
}
